import React, { Component } from "react";
import { connect } from "react-redux";
import { Tab, Tabs } from "react-bootstrap";
import { Register, Login } from '../../components/auth'
import Page from "./Page";
import { ROUTE_REGISTER } from "../../config/routes";
import { FormattedMessage } from 'react-intl';
import { Messages } from '../../components/general/Messages';
import { MessageModal } from '../../components/modals/MessageModal';
import { FormattedHTMLMessage } from "react-intl";
import { getParamFromUrl } from "../../api/helper";
import { loginCognito } from "../../api/user";
import { requestLogin } from "../../store/actions/user";
import { buildVidantaSsoLoginUrl, VIDANTA_SSO_LOGIN_URL } from "../../config/config";
import { getCurrentLanguage } from "../../helpers/language";

class AuthComponent extends Component {
    constructor(props) {
        super( props );
        this.state = {
            activeTab: this.props.location.pathname === ROUTE_REGISTER ? 'register' : 'login',
            showModal: true,
            showed: false,
            alerted: localStorage.getItem('alerted') || false,
            processingExternalLogin: false
        }

    }

    componentDidMount() {
        this.handleExternalLogin();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.handleExternalLogin();
        }
    }

    changeTab = (tab) => {
        if (tab === this.state.activeTab) {
            return;
        }

        this.setState( { activeTab: tab } );
        this.props.history.push( tab );
    };

    closeModal = () => {
        this.setState({
            showModal: false,
            showed: true
        });
    }

    handleExternalLogin = () => {
        const token = getParamFromUrl('authResponse', this.props);

        if (!token || this.state.processingExternalLogin) {
            return;
        }

        this.setState({
            processingExternalLogin: true
        });

        loginCognito({
            data: {
                token
            }
        }).then(response => {
            if (response && (response.status === 200 || response.status === 201)) {
                this.props.requestLogin(response);
                return;
            }

            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: '',
                hash: this.props.location.hash
            });
        }).finally(() => {
            this.setState({
                processingExternalLogin: false
            });
        });
    }

    render() {
        const ssoLoginUrl = buildVidantaSsoLoginUrl(getCurrentLanguage(this.props.locale));

        return (
            <Page class={`${this.state.activeTab}-container`} locate={this.props.locale}>
                {/*TODO Change this TAB component with material*/}
                {!VIDANTA_SSO_LOGIN_URL && (
                    <Tabs
                        id="authTab"
                        activeKey={this.state.activeTab}
                        onSelect={this.changeTab}>
                        <Tab eventKey="login" title={<FormattedMessage id="auth.login"/>}>
                            <Login />
                        </Tab>
                        <Tab eventKey="register" title={<FormattedMessage id="auth.register"/>}>
                            <Register/>
                        </Tab>
                    </Tabs>
                )}

                {VIDANTA_SSO_LOGIN_URL && (
                    <div className="auth-sso-link-container">
                        <a className="login-sso-link" href={ssoLoginUrl}>
                            <FormattedMessage id="login.with_vidanta_sso"/>
                        </a>
                    </div>
                )}
                <Messages />
            </Page>
        )
    }
}

const mapStateToProps = state => ( {
    locale: state.locale.lang,
    loading: state.loading.pendingRequests
} );

const Auth = connect( mapStateToProps, { requestLogin } )( AuthComponent );

export { AuthComponent, Auth };
